import { render, staticRenderFns } from "./PromoModal.vue?vue&type=template&id=319c63b7&scoped=true&"
import script from "./PromoModal.vue?vue&type=script&lang=js&"
export * from "./PromoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319c63b7",
  null
  
)

export default component.exports